import { useSelector } from 'react-redux';

const DynamicCategoryMessage = ({ categoryId, pageType, pdpRegion, vasData }) => {
    const dynamicContentAssets = useSelector(state => state.commonReducer.dynamicContentAssets);
    const categoryHierarchy = useSelector(state => state.commonReducer.categoryHierarchyData);
    const isCustomLogoAllowed = JSON.stringify(vasData || {}).toLowerCase().indexOf('customlogo') > -1;

    if (!dynamicContentAssets || !categoryId || !categoryHierarchy || !pageType) {
        return null;
    }

    let messagesToFilter = dynamicContentAssets.filter(asset => asset.Conditions.Pages.includes(pageType));

    // If pageType is 'pdp' and a pdpRegion is provided, further filter by PDPRegion.
    if (pageType === 'pdp' && pdpRegion) {
        messagesToFilter = messagesToFilter.filter(asset => asset.Conditions.PDPRegion === pdpRegion);
    }

    const getMatchingMessages = () => {
        return messagesToFilter.filter(asset => {
            // Embroidery check for PDP
            if (pageType === 'pdp' && typeof asset.Conditions.CustomLogoRequired === 'boolean') {
                if (asset.Conditions.CustomLogoRequired !== isCustomLogoAllowed) {
                    return false; // Does not match custom logo requirement
                }
            }

            if (!asset.Conditions.Categories) return false;

            return asset.Conditions.Categories.some(condition => {
                if (condition.Id === categoryId) {
                    return true;
                }
                if (condition.IncludeChildCategories) {
                    const conditionCategoryInHierarchy = categoryHierarchy[condition.Id];
                    if (conditionCategoryInHierarchy && conditionCategoryInHierarchy.allChildrenIds) {
                        return conditionCategoryInHierarchy.allChildrenIds.includes(categoryId);
                    }
                }
                return false;
            });
        });
    };

    const matchingMessages = getMatchingMessages();

    return (
        <>
            {matchingMessages.map((asset, index) => (
                <div key={index} className='text-danger pb-2' dangerouslySetInnerHTML={{ __html: asset.Message }}></div>
            ))}
        </>
    );
};

export default DynamicCategoryMessage;
